(() => {
  const dialog = document.getElementById('sca-image-viewer');
  if (!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const photos = JSON.parse(dialog.querySelector('[data-viewer-images]').textContent);
  const picture = dialog.querySelector('[data-viewer-picture]');
  const counter = dialog.querySelector('[data-viewer-counter]');
  const previous = dialog.querySelector('[data-viewer-previous]');
  const next = dialog.querySelector('[data-viewer-next]');
  const close = dialog.querySelector('[data-viewer-close]');
  let active = [], index = 0, opener, scrollY = 0, savedStyle;
  const key = (url) => { try { return new URL(url, location.href).pathname; } catch { return url; } };
  const paint = () => {
    const photo = active[index];
    picture.src = photo.src;
    picture.alt = photo.alt;
    picture.width = photo.width;
    picture.height = photo.height;
    counter.textContent = `${index + 1} / ${active.length}`;
    previous.disabled = next.disabled = active.length < 2;
  };
  const move = (delta) => { index = (index + delta + active.length) % active.length; paint(); };
  const open = (trigger) => {
    if (dialog.open) return;
    const gallery = trigger.closest('.scapd-gallery, .product-gallery');
    const current = trigger.querySelector('img');
    if (!current) return;
    const thumbnails = [...gallery.querySelectorAll('[data-scapd-image], .thumbnail[data-src]')].filter(el => !el.hidden);
    const allowed = new Set(thumbnails.map(el => key(el.dataset.scapdImage || el.dataset.src)));
    active = allowed.size ? photos.filter(photo => allowed.has(key(photo.src))) : [...photos];
    const currentKey = key(current.getAttribute('src') || current.currentSrc);
    if (!active.some(photo => key(photo.src) === currentKey)) {
      const selected = photos.find(photo => key(photo.src) === currentKey);
      if (selected) active.unshift(selected);
    }
    if (!active.length) return;
    index = Math.max(0, active.findIndex(photo => key(photo.src) === currentKey));
    opener = trigger;
    paint();
    scrollY = window.scrollY;
    savedStyle = document.body.getAttribute('style');
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    dialog.showModal();
    close.focus();
  };
  const setup = () => {
    document.querySelectorAll('.scapd-gallery .scapd-photo, .product-gallery .main-image').forEach(trigger => {
      if (!trigger.querySelector('img') || trigger.dataset.viewerReady) return;
      trigger.dataset.viewerReady = 'true';
      trigger.classList.add('sca-image-zoom-trigger');
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      trigger.setAttribute('aria-label', dialog.dataset.openLabel);
      trigger.setAttribute('aria-haspopup', 'dialog');
      const hint = document.createElement('span');
      hint.className = 'sca-image-zoom-hint';
      hint.setAttribute('aria-hidden', 'true');
      hint.textContent = '⌕';
      trigger.append(hint);
      trigger.addEventListener('click', () => open(trigger));
      trigger.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); open(trigger); }
      });
    });
  };
  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  close.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1);
    }
  });
  dialog.addEventListener('close', () => {
    if (savedStyle === null) document.body.removeAttribute('style');
    else document.body.setAttribute('style', savedStyle);
    window.scrollTo({top: scrollY, behavior: 'instant'});
    if (opener?.isConnected) opener.focus({preventScroll: true});
  });
  setup();
  document.addEventListener('shopify:section:load', setup);
})();
